// A sport's season as a new league meets it: which weeks it can start with,
// and what each period is called. `GET /api/sports/:sport/calendar`,
// PLAN-2026-09-24 item A.
//
// The create form asks it with the draft time it is about to send, so the
// weeks it offers are exactly the ones `POST /api/leagues` will accept; the
// pre-draft screen asks it for the one thing a league in setup cannot say for
// itself, which is that period 3 is called "Week 3".

import { SeasonCalendarView } from '@fsp/domain';
import { useRead, type Read } from './read';

export function useSeasonCalendar(
  sport: string | null,
  season: number | null,
  after: string | null = null,
): Read<SeasonCalendarView | null> {
  const path =
    sport === null || season === null
      ? null
      : `/sports/${sport}/calendar?season=${season}` +
        (after === null ? '' : `&after=${encodeURIComponent(after)}`);
  return useRead(path, SeasonCalendarView);
}

/** "Week 3", from the calendar, or the index itself while it has not arrived. */
export function periodName(view: SeasonCalendarView | null, index: number): string {
  return view?.periods.find((p) => p.index === index)?.label ?? `Week ${index}`;
}
